
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"443","height":"979","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".2","d":"M351.341 780.958s-12.562-242.187 61.882-423.439.078-352.413-164.199-385.265C84.747-60.598-163.413 31.928-323.118-150.294c-159.705-182.223-368.305 27.981-575.723 241.443-207.419 213.462 279.005 521.136 279.005 521.136s474.371 320.756 717.164 362.923c242.794 42.162 254.013-194.25 254.013-194.25z","fill":"url(#paint0_linear_170_84)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_170_84","x1":"-962.36","y1":"105.788","x2":"345.939","y2":"691.045","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#15DCD5"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#011E7D","stop-opacity":"0"}})])])])
          )
        }
      }
    